import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

// Create the slice
const TransaPicture = createSlice({
  name: "pictures",
  initialState,
  reducers: {
    Starting(state) {
      state.loading = true;
      state.error = null;
    },
    Success(state, action) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    CloseSuccess(state, action) {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
    Failure: (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload;
    },
  },
});

export const { Starting, Success, Failure, CloseSuccess } =
  TransaPicture.actions;

export const TransactionPicture = (file) => async (dispatch) => {
  dispatch(Starting());
  try {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post("/private/singleimage", formData, config);
    if (response?.status === 201) {
      // const returnedTarget = prev?.length
      //   ? prev.concat(response?.data)
      //   : response?.data;
      dispatch(Success(response?.data));
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || err);
    dispatch(Failure(err?.response?.data?.message || err));
  }
};

export default TransaPicture.reducer;
